<template>
  <div class="ui padded centered grid">

    <nav-details-top></nav-details-top>

    <div class="sixteen wide column">
      <h2 class="ui big header">Add New Patient</h2>
      <div class="ui divider"></div>
    </div>

    <div class="row">
      <div class="eight wide column">
        <h3 class="ui header" style="margin-bottom:0;"><i class="user icon"></i>Patient Creation</h3>
        <h3 class="ui dividing header" style="margin-top:0;"><span
          class="sub header">Add patient profile information</span></h3>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div class="row" v-if="isMBUser !== true">
        <div class="eight wide column">
          <div class="ui form" id="validate-mb-user-form">
            <div class="field">
              <label>Patient Email</label>
              <input id="email" name="email" type="email" placeholder="This must be their Migraine Buddy email" v-model="patientEmail">
            </div>
            <div class="ui primary button" style="margin-top:0.5em;" @click="validateMBUser">
              Check for MB Account
            </div>
            <div class="ui error message"></div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="eight wide column" v-if="isMBUser === true">
        <div @submit.prevent @keydown.enter.prevent id="patient-creation-form" class="ui form">
          <patient-profile-create
            :patientEmail="patientEmail"
            :inheritedPatientData="coaching"
            @updatePatientData="updateLocalCoachingData"
            ></patient-profile-create>
        </div>
      </div>
    </transition>


    <br><br>

    <transition name="fade" mode="out-in">
      <div class="sixteen wide column" v-if="isMBUser === true">
        <h3 class="ui header" style="margin-bottom:0;">Action Plan</h3>
        <h3 class="ui dividing header" style="margin-top:0;">
          <span class="sub header">Assign specific actions to this patient</span>
        </h3>
        <form @submit.prevent @keydown.enter.prevent class="ui form">

          <!--This emits changes to selectedActionPlanIdList for recomputation-->
          <patient-action-plan-table
            :selectedActionPlanIdList="selectedActionPlanIdList"
            @updateActions="updatedSelectedActionPlanIdList"
            @updateNewOnlyActions="updateNewOnlyActions"></patient-action-plan-table>

          <!--This emits changes to selectedActionPlanIdList for recomputation-->
          <patient-action-plan-button-dropdown
            :medgateId="coaching.medgateId"
            :patientObjective="coaching.objective"
            :patientNotes="coaching.coachNotes"
            :selectedIdList="selectedActionPlanIdList"
            @updateActions="updatedSelectedActionPlanIdList"></patient-action-plan-button-dropdown>

          <!--This emits changes to selectedActionPlanIdList for recomputation-->
          <patient-action-item-button-dropdown
            :medgateId="coaching.medgateId"
            :patientObjective="coaching.objective"
            :patientNotes="coaching.coachNotes"
            :selectedIdList="selectedActionPlanIdList"
            @updateActions="updatedSelectedActionPlanIdList"></patient-action-item-button-dropdown>
          <br><br>

          <h3 class="ui header" style="margin-bottom:0;">Lesson Plan</h3>
          <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">Assign specific lessons to this patient</span>
          </h3>

          <!--This emits changes to the selectedLessonPlanIdList so that everything recomputes-->
          <patient-lesson-plan-table
            :selectedLessonPlanIdList="selectedLessonPlanIdList"
            @updateLessons="updatedSelectedLessonPlanIdList"
            @updateNewOnlyLessons="updateNewOnlyLessons"
          ></patient-lesson-plan-table>

          <!--This emits changes to the selectedLessonPlanIdList so that everything recomputes-->
          <patient-lesson-plan-button-dropdown
            :medgateId="coaching.medgateId"
            :patientObjective="coaching.objective"
            :patientNotes="coaching.coachNotes"
            :selectedIdList="selectedLessonPlanIdList"
            @updateLessons="updatedSelectedLessonPlanIdList"></patient-lesson-plan-button-dropdown>

          <!--This emits changes to the selectedLessonPlanIdList so that everything recomputes-->
          <patient-lesson-item-button-dropdown
            :medgateId="coaching.medgateId"
            :patientObjective="coaching.objective"
            :patientNotes="coaching.coachNotes"
            :selectedIdList="selectedLessonPlanIdList"
            @updateLessons="updatedSelectedLessonPlanIdList"></patient-lesson-item-button-dropdown>

          <br>
          <br>
          <br>
          <br>

          <button @click="postPatientDetails(true)"
                  type="submit" class="ui big primary button"
                  :class="{ disabled: loadingState}">
            <i class="save icon"></i> Save Patient
          </button>

          <button @click="postPatientDetails(false)"
                  type="submit" class="ui big basic primary button"
                  :class="{ disabled: loadingState}">
            Save and Add Another Patient
          </button>

        </form>
        <div class="ui error message" :class="{ hidden: !displayError }">
          <p>One or more patient information fields contain errors.</p>
        </div>
        <div class="ui error message" :class="{ hidden: !displayDuplicateUserError }">
          <p>This patient has already been added to coaching program.</p>
        </div>
        <div class="ui error message" :class="{ hidden: !displayCatchAllError }">
          <p>Sorry! Something has gone wrong. Please try again later.</p>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';

  import NavDetailsTop from '../NavDetailsTop.vue'
  import PatientProfileCreate from './PatientProfileCreate.vue'

  import PatientActionPlanTable from './PatientActionPlanTable.vue'
  import PatientActionPlanButtonDropdown from './PatientActionPlanButtonDropdown.vue'
  import PatientActionItemButtonDropdown from './PatientActionItemButtonDropdown.vue'

  import PatientLessonItemButtonDropdown from './PatientLessonItemButtonDropdown.vue'
  import PatientLessonPlanButtonDropdown from './PatientLessonPlanButtonDropdown.vue'
  import PatientLessonPlanTable from './PatientLessonPlanTable.vue'

  import { quillEditor } from 'vue-quill-editor'
  import dataStructure from '../../validation/dataStructure'

  export default {
    components: {
      NavDetailsTop,
      PatientActionPlanButtonDropdown,
      PatientActionItemButtonDropdown,
      PatientActionPlanTable,
      PatientProfileCreate,
      PatientLessonPlanButtonDropdown,
      PatientLessonItemButtonDropdown,
      PatientLessonPlanTable,
      quillEditor
    },
    data() {
      //NOTE: The ui calendar inputs cannot be binded to the v-model because there is JS scripts modifying the content which will not show up in the v-model
      return {
        isMBUser: false,
        patientMBUserId: null,
        patientEmail: null,
        coaching: JSON.parse(JSON.stringify(dataStructure.profilePlanStructure.data)),
        selectedLessonPlanIdList: [],
        selectedActionPlanIdList: [], //Array of numbers!!!
        newOnlyActionContent: [],
        newOnlyLessonContent: [],
        displayError: false,
        displayDuplicateUserError: false,
        displayCatchAllError: false,
        loadingState: false
      }
    },
    computed: {
      ...mapState(['userAuthToken', 'coachingLessonPlansAll', 'coachingActionPlansAll', 'coachingLessonsAll', 'coachingActionsAll']),
    },
    methods: {
      ...mapMutations(['addNewPatient']),
      updateNewOnlyLessons: function(payload){
        this.newOnlyLessonContent = payload;
      },
      updateNewOnlyActions: function(payload){
        this.newOnlyActionContent = payload;
      },
      updateLocalCoachingData(payload){
        this.coaching = Object.assign(this.coaching, payload);
      },
      validateMBUser: function () {
        let validationStatus = $('#validate-mb-user-form').form('validate form');
        if (validationStatus === true ) {
          // Post call to validate if this patient has a MB account.
          // TODO: Form validation that this is an email address =)
          let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/userByEmail/' + this.patientEmail;
          this.$http.get(requestUrl).then((response)=> {
            this.patientMBUserId = response.body.result.id;
            this.coaching.language = response.body.result.defaultLang;
            this.isMBUser = true;
          },(error) => {
            if (error.status !== 404) {
              Rollbar.error("Error in validating MB User", error);
            }
            else {
              $('#validate-mb-user-form').form('add errors' , ['No Migraine Buddy user found for this email address. Please advise patient to download Migraine Buddy or check their email address.']);
            }
          });
        }
        else {
          $('#validate-mb-user-form').form('validate form');
        }
      },
      updatedSelectedActionPlanIdList: function(newIdList){
        this.selectedActionPlanIdList = newIdList;
      },
      updatedSelectedLessonPlanIdList: function(newIdList){
        this.selectedLessonPlanIdList = newIdList;
      },
      constructPatientActionTracking: function(){
        /* Two Outputs: Daily Tracking and One-Time Tracking
        *  Both outputs an array of objects with 2 keys: id and trackingStatus
        *  dailyTracking: [ {
        *  id: actionPlanId
        *  trackingStatus : [ { timestamp: 123, completionStatus: null}, { timestamp: 127, completionStatus: null} ] }]
        */

        //Based on start day of patient, create all the days that this patients need to track for this action plan
        let coachingLocalStart = new Date($('#coaching-start-date').val()).getTime();
        let coachingUTCStart = this.convertLocaltoUTCTimeStamp(coachingLocalStart);

        let payload = { dailyTracking: [], oneTimeTracking: [], notTrackable: [] };
        this.newOnlyActionContent.forEach((element)=>{
          //practicing paranoia
          if (element.data.options.userTracking.status.toString() === 'true') {
            if (element.data.options.userTracking.isDaily.toString() === 'true') {

              payload.dailyTracking.push({
                id: element.id,
                trackingStatus: []
              });

              let currentDailyTrackingIndex = payload.dailyTracking.length -1;
              for (let i = 0; i < (parseInt(element.data.options.endDay) - parseInt(element.data.options.startDay) + 1); i++){
                payload.dailyTracking[currentDailyTrackingIndex].trackingStatus.push({
                  startTimestamp: coachingUTCStart + (86400000 * (i + parseInt(element.data.options.startDay) - 1)),
                  endTimestamp: coachingUTCStart + (86400000 * (i + parseInt(element.data.options.startDay) - 1)),
                  completionStatus: null });
              }
            }
            else if (element.data.options.userTracking.isDaily.toString() === 'false') {
              payload.oneTimeTracking.push({
                id: element.id,
                trackingStatus: [{
                  startTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.startDay) - 1)),
                  endTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.endDay) - 1)),
                  completionStatus: null}],
              });
            }
            else {
              Rollbar.error("Program Plan Id: " + element.id + "has illegal syntax");
            }
          }
          else {
            payload.notTrackable.push({
              id: element.id,
              trackingStatus: [{ startTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.startDay) - 1)), endTimestamp: coachingUTCStart + (86400000 * (parseInt(element.data.options.endDay) - 1)) } ]
            });
          }
        });

        return payload
      },

      //constructs plans with userplans & reminders
      constructPatientUserPlans: function() {

        //Note: this.newOnlyActionContent && newOnlyLessonContent is associated with the store content and thus the ugly JSON.parse
        let userPlansAll = this.newOnlyActionContent.concat(this.newOnlyLessonContent);
        userPlansAll = JSON.parse(JSON.stringify(userPlansAll));

        //Based on start day of patient, create all the days that this patients need to track for this action plan
        let coachingLocalStart = new Date($('#coaching-start-date').val()).getTime();
        let coachingUTCStart = this.convertLocaltoUTCTimeStamp(coachingLocalStart);

        let userPlansWithId = userPlansAll.map(function(element) {
          element.data.id = element.id;

          // converts integer start and end day into a timestamp
          element.data.options.startTimestamp = coachingUTCStart + (86400000 * (parseInt(element.data.options.startDay) - 1));

          if (element.planType === 'action') {
            element.data.options.endTimestamp =  coachingUTCStart + (86400000 * (parseInt(element.data.options.endDay) - 1));

            // init reminders property so that patient can just make a single PUT call
            // copying the relevant parts of element.data.reminder over so can update the reminder object
            element.reminders = [{
              title: element.data.options.reminder.title,
              body: element.data.options.reminder.body,
              data: {
                notification: {
                  buddyId: process.env.BUDDY_BOT_ID,
                  timestamps: []
                },
                isDaily: element.data.options.reminder.isDaily,
                alarmDate: null,  // Not rendered in backoffice
                alarmTime: null, //Not rendered in backoffice
              }
            }];
          }
          return element
        });

        return userPlansWithId;
      },
      initPatientValidation: function() {
        $('#validate-mb-user-form')
          .form({
            fields: {
              'email': {
                identifier: 'email',
                rules: [
                  { type: 'empty', prompt: 'This cannot be empty' },
                  { type: 'email' }
                ]
              },
            },
            inline: true,
            keyboardShortcuts: false
          })
      },
      constructNewPatient() {
        // Note: Super weird and hackish constructor because we're using Semantic UI Calendar
        // Only the dates need to grab from document.querySelector. Everthing else should have been emitted
        // This grabs all the time related inputs when "Save Patient Details" is pressed
        this.coaching.startDate = document.getElementById('coaching-start-date').value.length > 0 ? this.convertLocaltoUTCTimeStamp(new Date(document.getElementById('coaching-start-date').value)) : null;
        this.coaching.docAppt.timestamp = document.getElementById('next-doctor-appointment').value.length > 0 ? this.convertLocaltoUTCTimeStamp(new Date(document.getElementById('next-doctor-appointment').value), true, true) : null;
        this.coaching.coachAppt.timestamp = document.getElementById('next-nurse-appointment').value.length > 0 ? this.convertLocaltoUTCTimeStamp(new Date(document.getElementById('next-nurse-appointment').value), true, true) : null;

        // Constructs new Patient data with action tracking initalized + userPlans
        let patientData = {
          consent: false,
          userId: this.patientMBUserId,
          userPlans: [],
          data: {}
        };

        let patientProfilePlan = dataStructure.profilePlanStructure;
        patientProfilePlan.data = Object.assign({}, this.coaching, this.constructPatientActionTracking());

        patientData.userPlans = this.constructPatientUserPlans().concat(patientProfilePlan);

        return patientData;

      },
      postPatientDetails: function(redirect) {
        this.displayError = false;
        this.displayDuplicateUserError = false;
        this.displayCatchAllError = false;

        let validationStatus = $('#patient-creation-form').form('is valid');
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programUser';

        if (validationStatus === true) {
          this.loadingState = true;
          this.$http.post(requestUrl, this.constructNewPatient()).then( (response) => {
            if (redirect === true) {
              this.getProgramPatients().then(()=> {
                this.loadingState = false;
                this.$router.push({name: 'TabPatient'});
              });
            }
            else {
              window.scrollTo(0,0);
              this.loadingState = false;
              this.$router.go({name: 'PagePatientCreate', force: true});
            }
          }, (error) => {
            this.loadingState = false;
            if (error.status === 422) {
              this.displayDuplicateUserError = true;
            }
            else {
              this.displayCatchAllError = true;
              Rollbar.error("Failure in Patient Creation", error)
            }
            window.requestAnimationFrame(()=>{
              window.scrollTo(0,document.body.scrollHeight);
            });
          })
        }
        else {
          this.displayError = true;
          $('#patient-creation-form').form('validate form');
          window.requestAnimationFrame(()=>{
            window.scrollTo(0,document.body.scrollHeight); // this scrolls to the bottom so that the help message at the bottom can be visible
          });
        }

      }
    },
    mounted() {
      // FIXME: Move this to the watch for MB userid later :) Or move this into the success callback of the MB userid checking
      $('.ui.dropdown').dropdown();
      this.initPatientValidation();
    }
  }
</script>


<style scoped>
  .fade-enter-active {
    transition: opacity 1s;
  }

  .fade-leave-active {
    display: none;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/patients/PagePatientCreate.vue